import React from 'react';
import { IconProps } from '../../DefaultIcon';

export function Business2Icon({ className }: IconProps) {
  return (
    <svg
      width="102"
      height="91"
      viewBox="0 0 102 91"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1147_1476)">
        <path
          d="M40.8769 81.5806C40.0561 81.5806 39.3994 80.9253 39.3994 80.1062V1.47435C39.3994 0.655266 40.0561 0 40.8769 0C41.6977 0 42.3543 0.655266 42.3543 1.47435V80.1062C42.3543 80.9253 41.6977 81.5806 40.8769 81.5806Z"
          fill="#00C4B3"
        />
        <path
          d="M14.857 81.5806C14.6654 81.5806 14.4466 81.526 14.255 81.4441C13.5163 81.1165 13.1606 80.2428 13.4889 79.4783L39.5361 20.8594C39.8645 20.1222 40.74 19.7672 41.5061 20.0949C42.2448 20.4225 42.6005 21.2962 42.2722 22.0607L16.225 80.7069C15.9787 81.253 15.4315 81.5806 14.857 81.5806Z"
          fill="#00C4B3"
        />
        <path
          d="M66.8965 81.5805C66.3219 81.5805 65.7747 81.2529 65.5284 80.7068L39.536 22.0606C39.2076 21.3234 39.536 20.4497 40.302 20.0948C41.0408 19.7671 41.9163 20.0948 42.272 20.8592L68.2919 79.5055C68.6202 80.2427 68.2919 81.1164 67.5258 81.4713C67.3342 81.5532 67.1154 81.6078 66.9238 81.6078"
          fill="#00C4B3"
        />
        <path
          d="M79.9199 9.28296H1.86035V64.9259H79.9199V9.28296Z"
          fill="#EAEDF8"
        />
        <path
          d="M81.0145 5.56982H0.738734C0.328326 5.56982 0 5.89746 0 6.307V8.51852C0 8.92806 0.328326 9.25569 0.738734 9.25569H81.0145C81.4249 9.25569 81.7532 8.92806 81.7532 8.51852V6.307C81.7532 5.89746 81.4249 5.56982 81.0145 5.56982Z"
          fill="#00C4B3"
        />
        <path
          d="M81.0145 64.8987H0.738734C0.328326 64.8987 0 65.2263 0 65.6359V67.8474C0 68.2569 0.328326 68.5846 0.738734 68.5846H81.0145C81.4249 68.5846 81.7532 68.2569 81.7532 67.8474V65.6359C81.7532 65.2263 81.4249 64.8987 81.0145 64.8987Z"
          fill="#00C4B3"
        />
        <path
          d="M48.1549 59.3287V16.6545C48.1549 15.9993 47.3614 15.6717 46.8689 16.1358L38.0862 25.0365C37.7579 25.3641 37.2654 25.446 36.855 25.2822L31.3829 22.9069C30.9724 22.7158 30.48 22.825 30.1516 23.1526L22.9285 30.4151C22.5728 30.7701 22.0256 30.852 21.5878 30.6062L16.9365 27.9033C16.4714 27.6302 15.8968 27.7395 15.5411 28.1217L7.41504 37.2135V59.356H48.1275L48.1549 59.3287Z"
          fill="#EAEDF8"
        />
        <path
          d="M37.7305 40.5991L31.4923 37.4866C31.0272 37.2682 30.4526 37.3774 30.1243 37.7869L22.5454 47.0426C22.2171 47.4521 21.6151 47.5613 21.15 47.3156L15.8968 44.5034C15.459 44.2577 14.9118 44.3396 14.5835 44.6945L7.41504 51.9297V59.3561H52.0127V29.2139C52.0127 28.5586 51.2192 28.231 50.7541 28.6951L39.0164 40.408C38.6881 40.7356 38.1683 40.8175 37.7305 40.6264"
          fill="#00416B"
        />
        <path
          d="M25.6911 46.9881C25.6911 49.0358 24.0221 50.7012 21.9701 50.7012C19.918 50.7012 18.249 49.0358 18.249 46.9881C18.249 44.9404 19.918 43.2749 21.9701 43.2749C24.0221 43.2749 25.6911 44.9404 25.6911 46.9881Z"
          fill="#FAFBFD"
        />
        <path
          d="M34.4196 22.5794C34.4196 24.6271 32.7506 26.2926 30.6986 26.2926C28.6465 26.2926 26.9775 24.6271 26.9775 22.5794C26.9775 20.5317 28.6465 18.8662 30.6986 18.8662C32.7506 18.8662 34.4196 20.5317 34.4196 22.5794Z"
          fill="#FAFBFD"
        />
        <path
          d="M42.1628 40.2168C42.1628 42.2645 40.4938 43.93 38.4417 43.93C36.3897 43.93 34.7207 42.2645 34.7207 40.2168C34.7207 38.1691 36.3897 36.5037 38.4417 36.5037C40.4938 36.5037 42.1628 38.1691 42.1628 40.2168Z"
          fill="#FAFBFD"
        />
        <path
          d="M24.2137 46.9879C24.2137 48.2165 23.2013 49.2267 21.9975 49.2267C20.7936 49.2267 19.7539 48.2165 19.7539 46.9879C19.7539 45.7593 20.7662 44.7764 21.9975 44.7764C23.2287 44.7764 24.2137 45.7593 24.2137 46.9879Z"
          fill="#00C4B3"
        />
        <path
          d="M32.9422 22.5794C32.9422 23.808 31.9572 24.7909 30.726 24.7909C29.4948 24.7909 28.4824 23.808 28.4824 22.5794C28.4824 21.3508 29.4948 20.3406 30.726 20.3406C31.9572 20.3406 32.9422 21.3508 32.9422 22.5794Z"
          fill="#00C4B3"
        />
        <path
          d="M40.6854 40.2169C40.6854 41.4455 39.673 42.4284 38.4418 42.4284C37.2106 42.4284 36.1982 41.4455 36.1982 40.2169C36.1982 38.9883 37.2106 38.0054 38.4418 38.0054C39.673 38.0054 40.6854 38.9883 40.6854 40.2169Z"
          fill="#00C4B3"
        />
        <path
          d="M22.7089 49.8821H21.2314V59.3288H22.7089V49.8821Z"
          fill="#FAFBFD"
        />
        <path
          d="M31.4374 25.4734H29.96V59.3288H31.4374V25.4734Z"
          fill="#FAFBFD"
        />
        <path
          d="M39.1806 43.1111H37.7031V59.3289H39.1806V43.1111Z"
          fill="#FAFBFD"
        />
        <path
          d="M52.0395 60.0932H7.44186C7.03145 60.0932 6.70312 59.7656 6.70312 59.3561V14.8253C6.70312 14.4158 7.03145 14.0881 7.44186 14.0881C7.85227 14.0881 8.18059 14.4158 8.18059 14.8253V58.5916H52.0395C52.4499 58.5916 52.7782 58.9192 52.7782 59.3288C52.7782 59.7383 52.4499 60.0659 52.0395 60.0659"
          fill="#00416B"
        />
        <path
          d="M9.65806 52.667H7.44186C7.03145 52.667 6.70312 52.3393 6.70312 51.9298C6.70312 51.5203 7.03145 51.1926 7.44186 51.1926H9.65806C10.0685 51.1926 10.3968 51.5203 10.3968 51.9298C10.3968 52.3393 10.0685 52.667 9.65806 52.667Z"
          fill="#00416B"
        />
        <path
          d="M9.65806 45.2407H7.44186C7.03145 45.2407 6.70312 44.9131 6.70312 44.5035C6.70312 44.094 7.03145 43.7664 7.44186 43.7664H9.65806C10.0685 43.7664 10.3968 44.094 10.3968 44.5035C10.3968 44.9131 10.0685 45.2407 9.65806 45.2407Z"
          fill="#00416B"
        />
        <path
          d="M9.65806 37.8415H7.44186C7.03145 37.8415 6.70312 37.5139 6.70312 37.1044C6.70312 36.6948 7.03145 36.3672 7.44186 36.3672H9.65806C10.0685 36.3672 10.3968 36.6948 10.3968 37.1044C10.3968 37.5139 10.0685 37.8415 9.65806 37.8415Z"
          fill="#00416B"
        />
        <path
          d="M9.65806 30.4153H7.44186C7.03145 30.4153 6.70312 30.0876 6.70312 29.6781C6.70312 29.2685 7.03145 28.9409 7.44186 28.9409H9.65806C10.0685 28.9409 10.3968 29.2685 10.3968 29.6781C10.3968 30.0876 10.0685 30.4153 9.65806 30.4153Z"
          fill="#00416B"
        />
        <path
          d="M9.65806 22.989H7.44186C7.03145 22.989 6.70312 22.6614 6.70312 22.2518C6.70312 21.8423 7.03145 21.5146 7.44186 21.5146H9.65806C10.0685 21.5146 10.3968 21.8423 10.3968 22.2518C10.3968 22.6614 10.0685 22.989 9.65806 22.989Z"
          fill="#00416B"
        />
        <path
          d="M9.65806 15.5898H7.44186C7.03145 15.5898 6.70312 15.2622 6.70312 14.8527C6.70312 14.4431 7.03145 14.1155 7.44186 14.1155H9.65806C10.0685 14.1155 10.3968 14.4431 10.3968 14.8527C10.3968 15.2622 10.0685 15.5898 9.65806 15.5898Z"
          fill="#00416B"
        />
        <path
          d="M67.7166 36.5037H77.7032C82.8196 36.5037 86.9784 40.6537 86.9784 45.7593V52.4485H81.6158V45.7593C81.6158 43.6024 79.8647 41.855 77.7032 41.855H67.7166C65.5551 41.855 63.8041 43.6024 63.8041 45.7593V52.4485H58.4414V45.7593C58.4414 40.6537 62.6002 36.5037 67.7166 36.5037Z"
          fill="#00416B"
        />
        <path
          d="M95.3513 90.9998H50.0697C47.1147 90.9998 44.7344 88.6245 44.7344 85.6758V53.7862C44.7344 50.8648 47.1147 48.4622 50.0697 48.4622H95.3513C98.3063 48.4622 100.687 50.8375 100.687 53.7862V85.6758C100.687 88.6245 98.3063 90.9998 95.3513 90.9998Z"
          fill="#00416B"
        />
        <path
          d="M94.0108 86.4677H51.4105C50.234 86.4677 49.2764 85.5121 49.2764 84.3381V55.0969C49.2764 53.9229 50.234 52.9673 51.4105 52.9673H94.0108C95.1873 52.9673 96.1449 53.9229 96.1449 55.0969V84.3381C96.1449 85.5121 95.1873 86.4677 94.0108 86.4677ZM51.4105 54.5781C51.1095 54.5781 50.8906 54.8239 50.8906 55.0969V84.3381C50.8906 84.6385 51.1369 84.8569 51.4105 84.8569H94.0108C94.3118 84.8569 94.5307 84.6111 94.5307 84.3381V55.0969C94.5307 54.7966 94.2844 54.5781 94.0108 54.5781H51.4105Z"
          fill="#00C4B3"
        />
        <path
          d="M68.6473 73.9629L49.3855 68.8846C45.8833 67.9563 43.4209 64.7892 43.4209 61.1852V53.7862C43.4209 50.8648 45.8013 48.4622 48.7562 48.4622H96.6918C99.6194 48.4622 102.027 50.8375 102.027 53.7862V61.1852C102.027 64.8165 99.592 67.9836 96.0625 68.8846L76.8007 73.9629C74.1194 74.6728 71.3286 74.6728 68.6473 73.9629Z"
          fill="#00C4B3"
        />
        <path
          d="M72.6962 70.5229C71.6565 70.5229 70.6441 70.3864 69.6318 70.1407L50.37 65.0624C48.6189 64.5982 47.3877 63.0147 47.3877 61.2127V53.8137C47.3877 53.0765 47.9896 52.4758 48.7284 52.4758H96.664C97.4027 52.4758 98.0047 53.0765 98.0047 53.8137V61.2127C98.0047 63.0147 96.7734 64.5982 95.0224 65.0624L75.7606 70.1407C74.7756 70.4137 73.7359 70.5229 72.6962 70.5229ZM49.002 54.0594V61.2127C49.002 62.3048 49.7407 63.2604 50.7804 63.5334L70.0422 68.6117C71.7659 69.0759 73.5991 69.0759 75.3501 68.6117L94.6119 63.5334C95.6516 63.2604 96.3904 62.3048 96.3904 61.2127V54.0594H49.002Z"
          fill="#00416B"
        />
        <g style={{ mixBlendMode: 'multiply' }}>
          <mask
            id="mask0_1147_1476"
            style={{ maskType: 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="66"
            y="63"
            width="13"
            height="13"
          >
            <path
              d="M78.689 63.2058H66.7051V75.1644H78.689V63.2058Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask0_1147_1476)">
            <mask
              id="mask1_1147_1476"
              style={{ maskType: 'luminance' }}
              maskUnits="userSpaceOnUse"
              x="66"
              y="63"
              width="13"
              height="13"
            >
              <path
                d="M68.4835 73.417C69.5779 74.5091 71.0554 75.1644 72.7244 75.1644C74.3934 75.1644 75.8708 74.4818 76.9653 73.417C78.0597 72.3249 78.7163 70.8506 78.7163 69.1851C78.7163 67.5196 78.0597 66.0453 76.9653 64.9532C75.8708 63.8611 74.3934 63.2058 72.7244 63.2058C71.0554 63.2058 69.5779 63.8611 68.4835 64.9532C67.3891 66.0453 66.7324 67.5196 66.7324 69.1851C66.7324 70.8506 67.4164 72.3249 68.4835 73.417Z"
                fill="white"
              />
            </mask>
            <g mask="url(#mask1_1147_1476)">
              <mask
                id="mask2_1147_1476"
                style={{ maskType: 'luminance' }}
                maskUnits="userSpaceOnUse"
                x="66"
                y="63"
                width="13"
                height="13"
              >
                <path
                  d="M78.689 63.2058H66.7051V75.1644H78.689V63.2058Z"
                  fill="white"
                />
              </mask>
              <g mask="url(#mask2_1147_1476)">
                <mask
                  id="mask3_1147_1476"
                  style={{ maskType: 'luminance' }}
                  maskUnits="userSpaceOnUse"
                  x="66"
                  y="63"
                  width="13"
                  height="13"
                >
                  <path
                    d="M78.689 63.2058H66.7051V75.1644H78.689V63.2058Z"
                    fill="white"
                  />
                </mask>
                <g mask="url(#mask3_1147_1476)">
                  <rect
                    x="66.459"
                    y="62.1138"
                    width="13.133"
                    height="13.1053"
                    fill="url(#pattern0)"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
        <path
          d="M76.6914 69.1849C76.6914 71.3965 74.913 73.1711 72.6968 73.1711C70.4806 73.1711 68.7021 71.3965 68.7021 69.1849C68.7021 66.9734 70.4806 65.1987 72.6968 65.1987C74.913 65.1987 76.6914 66.9734 76.6914 69.1849Z"
          fill="white"
        />
        <path
          d="M75.1045 69.1851C75.1045 70.4956 74.0375 71.5878 72.6968 71.5878C71.3561 71.5878 70.2891 70.5229 70.2891 69.1851C70.2891 67.8473 71.3561 66.7825 72.6968 66.7825C74.0375 66.7825 75.1045 67.8473 75.1045 69.1851Z"
          fill="#00416B"
        />
      </g>
      <defs>
        <pattern
          id="pattern0"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use
            xlinkHref="#image0_1147_1476"
            transform="scale(0.125 0.111111)"
          />
        </pattern>
        <clipPath id="clip0_1147_1476">
          <rect width="102" height="91" fill="white" />
        </clipPath>
        <image
          id="image0_1147_1476"
          width="8"
          height="9"
          xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAJCAYAAAAPU20uAAAACXBIWXMAABcRAAAXEQHKJvM/AAAAwklEQVQYlVWQyU4DMRAFq+22PQskSg75/8/jkggyxLPZbQ6DkKhzSaX3xMzaXoxSDe+FqIoIf+iyFe5fL/Kyod5zu7wx9BH3a+nHfWLKC49npk+Basbt8s5pTIgI+ni++JxmprySl41SKyCkqHRR0b0Yy7azlYK1hs475VSp1Y5EDJ4uBUo1YvAMXWDsI0HdIVxPA0E9fQpE9VzPI0OKqPcAyLxu7TuvLHsleMfYRYYu4tyxQsxas9ZorSECTty/H34Azr1YVxRucNIAAAAASUVORK5CYII="
        />
      </defs>
    </svg>
  );
}
